export enum RegistrationsTab {
  All = "All",
  INCOMPLETE = "INCOMPLETE",
  COMPLETE = "COMPLETE",
}
